import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import WhyUsSection from "@/components/WhyUsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="bg-[#0A0A0A] min-h-screen">
      <Toaster
        theme="dark"
        toastOptions={{
          style: {
            background: "#141414",
            border: "1px solid #262626",
            color: "#FFFFFF",
          },
        }}
      />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <WhyUsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
